import React, { useEffect, useState, useCallback } from "react";
import axios from "axios";
import config from "../config";

const TaskList = ({ selectedDate, onBackButtonClick, backButtonPressed }) => {
  const initData = window.Telegram.WebApp.initData;

  const [victories, setVictories] = useState({ mental: "", spiritual: "", physical: "", career: "" });
  const [tasks, setTasks] = useState({ main: "", min: "", secondary: "" });
  const [, setOriginalData] = useState({ victories: {}, tasks: {} });
  const [isModified, setIsModified] = useState(false);

  useEffect(() => {
    axios
      .post(`${config.API_BASE_URL}/calendar/get`, { selectedDate, initData })
      .then((response) => {
        if (response.data && Object.keys(response.data.data).length !== 0) {
          setVictories(response.data.data.victories || { mental: "", spiritual: "", physical: "", career: "" });
          setTasks(response.data.data.tasks || {});
          setOriginalData({
            victories: response.data.data.victories || {},
            tasks: response.data.data.tasks || {},
          });
        } else {
          setVictories({ mental: "", spiritual: "", physical: "", career: "" });
          setTasks({ main: "", min: "", secondary: "" });
          setOriginalData({ victories: {}, tasks: {} });
        }
      })
      .catch((error) => console.error("Ошибка загрузки данных календаря:", error));
  }, [selectedDate, initData]);
  useEffect(() => {
    document.querySelectorAll("textarea").forEach(adjustTextareaHeight);
  }, [victories, tasks]);

  const handleSave = useCallback(() => {
    axios
      .post(`${config.API_BASE_URL}/calendar/save`, { selectedDate, initData, victories, tasks })
      .then(() => {
        setOriginalData({ victories, tasks });
        setIsModified(false);
      })
      .catch((error) => console.error("Ошибка сохранения данных:", error));
  }, [selectedDate, initData, victories, tasks]);

  useEffect(() => {
    if (backButtonPressed) {
      onBackButtonClick(false);
      if (isModified) {
        handleSave();
      }
    }
  }, [backButtonPressed, handleSave, onBackButtonClick, isModified]);

  const adjustTextareaHeight = (textarea) => {
    if (textarea) {
      textarea.style.height = "auto";
      textarea.style.height = `${textarea.scrollHeight}px`;
    }
  };
  const handleChange = (e, setState) => {
    const { name, value } = e.target;
    setState((prevState) => {
      const newState = { ...prevState, [name]: value };
      setIsModified(true);
      return newState;
    });

    adjustTextareaHeight(e.target);
  };


  return (
    <div className="task-list">
      <div className="now-date">{selectedDate.toLocaleDateString('ru-RU')}</div>
      <div className="section victories">
        <div className="titles">
          <h3 className="section-title">Победы дня</h3>
        </div>
        <div className="input-group">
          <h4 className="input-label">Ментальная победа</h4>
          <textarea name="mental" value={victories.mental} maxLength={350} onChange={(e) => handleChange(e, setVictories)} />
        </div>
        <div className="input-group">
          <h4 className="input-label">Духовная победа</h4>
          <textarea name="spiritual" value={victories.spiritual} maxLength={350} onChange={(e) => handleChange(e, setVictories)} />
        </div>
        <div className="input-group">
          <h4 className="input-label">Физическая победа</h4>
          <textarea name="physical" value={victories.physical} maxLength={350} onChange={(e) => handleChange(e, setVictories)} />
        </div>
        <div className="input-group">
          <h4 className="input-label">Карьерная победа</h4>
          <textarea name="career" value={victories.career} maxLength={350} onChange={(e) => handleChange(e, setVictories)} />
        </div>
      </div>
      <div className="section tasks">
        <div className="titles">
          <h3 className="section-title">Список задач</h3>
        </div>
        <div className="input-group">
          <h4 className="input-label">Главные задачи</h4>
          <textarea name="main" value={tasks.main} maxLength={350} onChange={(e) => handleChange(e, setTasks)} />
        </div>
        <div className="input-group">
          <h4 className="input-label">Задачи менее 2х минут</h4>
          <textarea name="min" value={tasks.min} maxLength={350} onChange={(e) => handleChange(e, setTasks)} />
        </div>
        <div className="input-group">
          <h4 className="input-label">Второстепенные задачи</h4>
          <textarea name="secondary" value={tasks.secondary} maxLength={350} onChange={(e) => handleChange(e, setTasks)} />
        </div>
      </div>
    </div>
  );
};

export default TaskList;
